import React, { useEffect } from 'react'
import styles from './CircularMenu.module.scss'

export interface MenuItem {
    title: string;
    href: string;
}

interface CircularMenuProps {
    items: MenuItem[];
    onClose: () => void;
    radius?: number;
    device: number;
    ANGLES: number[];
    theme?: "Black";
}


const CircularMenu: React.FC<CircularMenuProps> = ({
    items,
    onClose,
    radius = 150,
    device,
    ANGLES,
    theme
}) => {
    const handleClick = () => {
        onClose();
    };
    return (
        <nav className={`${styles.nav_} ${theme ? styles[theme] : ""}`} style={{ width: device > 3 ? radius * 2 : "calc(100vw - 40px)", height: device > 3 ? radius * 2 : "60px" }}>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                <div className={styles.navInner}
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }}
                >

                    {device < 3 ?
                        items.map((item, index) => {

                            return (
                                <li
                                    key={index}
                                    className={styles.item}
                                    style={{
                                        position: 'relative',
                                        animationDelay: `${index * 0.12}s`,
                                    }}
                                >
                                    <a onClick={handleClick} href={item.href}>
                                        {item.title}
                                    </a>
                                </li>
                            );
                        })
                        : items.map((item, index) => {
                            const angleDeg = ANGLES[index] ?? 0;
                            const angleRad = (angleDeg * Math.PI) / 180;

                            const x = radius * Math.cos(angleRad);
                            const y = radius * Math.sin(angleRad);

                            return (
                                <li
                                    key={index}
                                    className={styles.item}
                                    style={{
                                        position: 'absolute',
                                        left: `${x}px`,
                                        top: `${y}px`,
                                        // Задержка: 0.12 секунды на каждый шаг (0s, 0.12s, 0.24s...)
                                        animationDelay: `${index * 0.12}s`,
                                    }}
                                >
                                    <a onClick={handleClick} href={item.href}>
                                        {item.title}
                                    </a>
                                </li>
                            );
                        })}
                </div>
            </ul>
        </nav>
    );
}

export default CircularMenu;